import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const carousels = document.querySelectorAll('.in_short_bloc');

  if (carousels) {
    carousels.forEach((carousel) => {
      const swiperSlide = carousel.querySelectorAll('.in_short_bloc__item');
      const fraction = carousel.querySelector(
        '.in_short_bloc-pagination-fraction'
      );
      const slideCount = swiperSlide.length;
      fraction.textContent = `1 / ${slideCount}`;

      if (1 < swiperSlide.length) {
        const InShortCarousel = new Swiper(carousel, {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination-bullets, .swiper-pagination-fraction',
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              fraction.textContent = `${
                InShortCarousel.snapIndex + 1
              } / ${slideCount}`;
            },
          },
          a11y: {
            enabled: true,
            prevSlideMessage: 'Diapositive précédente',
            nextSlideMessage: 'Diapositive suivante',
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
          },
          breakpoints: {
            200: {
              slidesPerView: 1.5,
              spaceBetween: 16,
            },
            992: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });

        InShortCarousel.init();
      } else {
        carousel.querySelector(
          '.in_short_bloc-pagination-fraction'
        ).style.display = 'none';
        carousel.querySelector(
          '.in_short_bloc-pagination-bullets'
        ).style.display = 'none';
      }
    });
  }
});
